const EmptyState = () => {
  return (
    <div className="text-center py-20">
      <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <i className="ri-calendar-close-line text-5xl text-gray-400"></i>
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-3">No events found</h3>
      <p className="text-gray-600 mb-8 max-w-md mx-auto">
        We couldn't find any events matching your filters. Try adjusting your search criteria or browse all events.
      </p>
      <button
        onClick={() => window.location.reload()}
        className="px-6 py-3 bg-gradient-to-r from-teal-500 to-cyan-600 text-white rounded-lg font-semibold hover:from-teal-600 hover:to-cyan-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
      >
        <i className="ri-refresh-line mr-2"></i>
        Reset Filters
      </button>
    </div>
  );
};

export default EmptyState;
